export const LogsActionTypes = {
  AUDIT_LOG_LIST_GETS: 'AUDIT_LOG_LIST_GETS',
  AUDIT_LOG_LIST_GET: 'AUDIT_LOG_LIST_GET',
  AUDIT_LOG_LIST_GETS_SUCCESSFUL: 'AUDIT_LOG_LIST_GETS_SUCCESSFUL',
  AUDIT_LOG_LIST_GETS_ERROR: 'AUDIT_LOG_LIST_GETS_ERROR',
  AUDIT_LOG_LIST_GET_SUCCESSFUL: 'AUDIT_LOG_LIST_GET_SUCCESSFUL',
  AUDIT_LOG_LIST_GET_ERROR: 'AUDIT_LOG_LIST_GET_ERROR',
}
